import { useContext, useEffect, useState } from 'react';
import { TextField, Button, CircularProgress, Card, CardContent, Typography } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import api from '../../../../services/api';
import { CadastroContext } from '../../../../contexts/CadastroContext';
import AlertMessage from '../../../Alert';
import { session, StorageKeys } from "../../../../services/storage.service";
import { AsoInformation } from "../../../../types/aso-information";

const AsoValidarEmail = () => {
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [buttonEnabled, setButtonEnabled] = useState(false);
    const navigate = useNavigate();
    const { dbName } = useParams();
    const location = useLocation();

    useEffect(() => {
        if (cadastro.editarCadastro && !cadastro.primeiraVez) return navigate(`/aso/registro/reconhecimento-facial/${cadastro.idConsulta}`);
    }, []);

    const handleInput = (event:any) => {
        const { value } = event.target;
        setButtonEnabled(value.trim() !== "");
        cadastro.email = value;
    };

    const handleSubmit = async () => {
        try {
            if (!cadastro.email || !cadastro.email.includes('@')) {
                setAlert({ show: true, message: "Insira um email válido.", variant: "danger" });
                return;
            }
            setLoading(true);
            const response = await api.get(`/verificar-email/${cadastro.email}`);
            const { emailEncontrado, message } = response.data;
    
            if (emailEncontrado) {
                session.set<AsoInformation>(StorageKeys.ASO_INFORMATION, { idConsulta: cadastro.idConsulta, email: cadastro.email, dbName: dbName!, primeiraVez: false });
                cadastro.primeiraVez = false;
                handleCadastroChange(cadastro);

                return navigate(`/aso/registro/validar-info-trabalhador-existente/${cadastro.idConsulta}`);
            } else if (!emailEncontrado && message) {
                setLoading(false);
                setAlert({ show: true, message, variant: "danger" });
            } else {
                // Caso o e-mail não esteja registrado, continue o fluxo normal
                session.set<AsoInformation>(StorageKeys.ASO_INFORMATION, { idConsulta: cadastro.idConsulta, email: cadastro.email, dbName: dbName!, primeiraVez: true });
                await api.post('/recebe-disparo-email', { email: cadastro.email });

                if (location.pathname === `/aso/registro/validar-email-aso/${dbName}`) {
                    navigate(`/aso/registro/validar-email-token-aso/${dbName}`);
                }else{
                    navigate(`/aso/registro/validar-email-token/${dbName}`);
                }
            }
        } catch (error) {
            setAlert({ show: true, message: "Erro ao validar email.", variant: "danger" });
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <>
            <AlertMessage 
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
            <Card 
                sx={{
                    maxWidth: 400, 
                    mx: 'auto', 
                    mt: 5,
                    padding: '50px'
                }}
            >
                <CardContent 
                    sx={{
                        boxShadow: 'none',
                        border: 'none',
                        p: 2
                    }}
                >
                    <Typography 
                        variant="h5" 
                        component="div" 
                        gutterBottom
                    >
                        <strong>Digite seu e-mail.</strong>
                    </Typography>
                    <Typography 
                        sx={{ mb: 1.5, fontSize: 15 }}
                    >
                        Certifique-se de ter acesso ao seu e-mail.
                    </Typography>
                    <Typography 
                        sx={{ mb: 1.5, fontSize: 15 }}
                    >
                        Vamos enviar um código para validá-lo.
                    </Typography>
                    <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="nome@example.com"
                        onChange={handleInput}
                        helperText="Use o formato nome@example.com"
                        disabled={loading}
                    />
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={!buttonEnabled || loading}
                        sx={{ mt: 2 }}
                    >
                        {loading ? <CircularProgress size={24} /> : 'Continuar'}
                    </Button>
                </CardContent>
            </Card>
        </>
    );
}

export default AsoValidarEmail;